// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__-wF_L","filesListContainer":"PosDisputesFiles_filesListContainer__3D5qd","filesButton":"PosDisputesFiles_filesButton__1Dinw"};